import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatSlideToggle, MatSlideToggleChange } from '@angular/material/slide-toggle';
import { PhitoUserDbVariableService } from '../../services/phito-user-db-variable.service';

@Component({
    selector: 'phito-toggle',
    templateUrl: './phito-toggle.component.html',
    styleUrls: ['./phito-toggle.component.css'],
    imports: [MatSlideToggle],
})
export class PhitoToggleComponent implements OnInit {
    @Input({ required: true }) componentUniqueId: string;
    @Input() label = '';
    @Input() disabled = false;
    @Output() changed = new EventEmitter<boolean>();

    checked = false;
    loading = false;

    constructor(private userVariableService: PhitoUserDbVariableService) { }

    ngOnInit(): void {
        if (!this.componentUniqueId) {
            throw new Error('Key nicht gesetzt!');
        }

        this.loading = true;
        this.userVariableService.getVariableAsBoolean(this.componentUniqueId).subscribe({
            next: (value: boolean) => {
                this.checked = value;
                this.loading = false;
                this.changed.emit(this.checked);
            },
            error: () => {
                this.loading = false;
                this.changed.emit(this.checked);
            },
        });
    }

    onToggle(change: MatSlideToggleChange): void {
        this.checked = change.checked;
        this.userVariableService.upsertVariable(this.componentUniqueId, this.checked);
        this.changed.emit(this.checked);
    }

}
